
import React from 'react';
import moment from "moment";
import 'moment/locale/en-gb';

import TransactionsForm from './TransactionsForm'
import TransactionsResults from './TransactionsResults'

export default class extends React.Component{

	constructor(props){
		super(props);

		this.state = {
			filter: {
				query: '',
				other_company: '',
				date_start: '',
				date_end: '',
				transaction_types: '',
				exemptions: '',
				filtering: false,
				reset: false
			},
			transactions: {},
			transaction_types: [],
			exemptions: {},
			results: [],
			loading: true
		}
	}

	componentDidMount(){
		$.ajax({
			url: '/transactions/transactions-register/fetch'
		}).then(
			response => {
				this.setState({
					transactions: response.Transactions,
					transaction_types: response.TransactionTypes,
					exemptions: response.Exemptions,
					loading: false
				});
				this.filterResults(this.state.filter, response.Transactions);
			},
			error => {
				this.setState({
					loading: false
				});
				console.error(error);
			}
		);
	}

	filterResults(filter = this.state.filter, transactions = this.state.transactions){

		var results = [];
		for (var key in transactions){			
		    if (transactions.hasOwnProperty(key)){

		    	var transaction = transactions[key];

		    	// if the reset button has been clicke (which sets filter.reset to true)
		    	if (filter.reset === true){

		    		// push all available transactions back into the list
		    		results.push(transaction);

		    		// reset filter.filtering to false
		    		filter.filtering = false;

		    	} else {
		    		var match = true;
		    		var transaction_date = moment(transaction.Date, "YYYY-MM-DD");

			    	// Query match (Title)
			    	if (filter.query !== ''){
			    		filter.filtering = true;
			    		if (!transaction.Title.toLowerCase().includes(filter.query)){
			    			match = false;
			    		}
			    	}

			    	// Other Company match
			    	if (filter.other_company !== ''){
			    		filter.filtering = true;
			    		if (!transaction.OtherCompany.toLowerCase().includes(filter.other_company)){
			    			match = false;
			    		}
			    	}

			    	// Date range match
			    	if (filter.date_start !== ''){
			    		filter.filtering = true;
			    		if (!transaction_date.isSame(moment(filter.date_start + "-01-01", "YYYY-MM-DD"), "year")){
			    			match = false;
			    		}
			    	}
			    	if (filter.date_end !== ''){
			    		filter.filtering = true;
			    		if (filter.date_start === filter.date_end) {
			    			// If both dates are the same, we're filtering for that year
			    			if (!transaction_date.isSame(filter.date_end + "-01-01", "year")) {
			    				match = false;
			    			}
			    		}

			    		if (!transaction_date.isSameOrBefore(moment(filter.date_end + "-12-31", "YYYY-MM-DD"))){
			    			match = false;
			    		}
			    	}

			    	// TransactionType match
			    	if (filter.transaction_types !== ''){
			    		filter.filtering = true;
			    		if (!transaction.TransactionType.toLowerCase().includes(filter.transaction_types)){
			    			match = false;
			    		}
			    	}

			    	// Exemptions match
			    	if (filter.exemptions !== ''){
			    		filter.filtering = true;
			    		if (transaction.Exemptions.toLowerCase() != filter.exemptions.toLowerCase()){
			    			match = false;
			    		}
			    	}

			    	if (match){	
			    		results.push(transaction);
			    	}

			    }

		    }
		}

		this.setState({
			results: results
		});

		filter.reset = false;
	}

	handleSubmit(filter){
		this.setState({
			filter: filter
		});
		this.filterResults(filter);
	}

	render(){
		if (this.state.loading){
			return (
				<div className="loader">
					<div className="circle"></div>
				</div>
			);
		} else {
			return (
				<div>
					<TransactionsForm 
						onSubmit={filter => this.handleSubmit(filter)}
						filter={this.state.filter}
						transaction_types={this.state.transaction_types}
						exemptions={this.state.exemptions}
					/>
					<TransactionsResults 
						results={this.state.results}
					/>
				</div>
			);
		}
	}
}


// WEBPACK FOOTER //
// ./site/js/components/TransactionsCore.js